import "@hybird/core/lib"

class ResultCode {
  _code;

  _msg;

  constructor(code, msg) {
    this._code = code;
    this._msg = msg;
  }

  /**
   * @return{Number}
   */
  get code() {
    return this._code;
  }

  /**
   * @return{String}
   */
  get msg() {
    return this._msg;
  }
}

const SYSTEM_ERROR = new ResultCode(400, "未知异常");

class WebError extends Error {
  /**
   * @type{Number}
   */
  code;

  /**
   * @type{String}
   */
  msg;

  /**
   * @type{Object}
   */
  data;

  /**
   * @type{ResultCode}
   */
  resultCode;

  error;

  /**
   *
   * @param code
   * @param msg
   * @param resultCode
   * @param data
   * @param error{Error}
   */
  constructor({
                resultCode = SYSTEM_ERROR,
                code = resultCode.code,
                msg = resultCode.msg,
                data = {},
                error
              }) {
    let message = code + ":" + msg;

    if (data) {
      message += "\ndata:" + JSON.stringify(data);
    }

    if (error) {
      message += "\nerror:" + (error.stack ? error.stack : error.message);
    }

    super(message);

    this.code = code;
    this.msg = msg;
    this.resultCode = resultCode;
    this.data = data;
    this.error = error;
  }

  /**
   *
   * @param resultCode
   * @param code{Number}
   * @param msg{String}
   * @param format
   * @param data
   * @param error
   * @return {WebError}
   */
  static code(resultCode = SYSTEM_ERROR, {
    code = resultCode.code,
    msg = resultCode.msg,
    format,
    data,
    error
  } = {}) {
    return new WebError({
      code: code,
      msg: format instanceof Array ? msg.format(...format) : msg,
      resultCode: resultCode,
      data: data,
      error: error
    });


  }

  static error(error, resultCode = SYSTEM_ERROR, format = []) {
    if (error instanceof WebError) {
      return error
    }

    return new WebError({
      resultCode: resultCode,
      error: error,
      format: format
    });
  }
}

const isError = (e, code) => {
  if (!(e instanceof WebError)) {
    return false;
  }
  if (code == null) {
    return true;
  } else if (typeof code === "number") {
    return e.code === code;
  } else if (code instanceof ResultCode) {
    return e.code === code.code;
  }

  return false;
}

const getErrorMsg = (e, code, defaultMsg = null) => {
  if (isError(e, code) || !defaultMsg) {
    return e.msg;
  } else {
    return defaultMsg;
  }
}

const defaultError = {
  SYSTEM_ERROR: SYSTEM_ERROR,
  NOT_LOGIN: new ResultCode(10000, "请登录后重试"),
  NOT_CONSTRUCTOR: new ResultCode(10001, "这个类不能被实例化"),
  ILLEGAL_ARGUMENT: new ResultCode(10002, "参数异常"),
  REQUEST_ERROR: new ResultCode(10003, "请求异常"),
  NOT_PERMISSION: new ResultCode(10004, "权限不足"),
  SUBSCRIBE_ERROR: new ResultCode(10005, "订阅异常"),
  SUBSCRIBE_ONE_READ_TIMEOUT: new ResultCode(10006, "连接设备超时"),
  CONNECT_ILLEGAL_ARGUMENT: new ResultCode(10007, "连接参数，参数错误"),
  NOT_CONNECT: new ResultCode(10008, "未连接"),
  USED_UP_THE_NUMBER_OF_TIMES: new ResultCode(10009, "用完使用次数"),
  NO_FINGERPRINT_RECORDED: new ResultCode(10010, "未录入指纹"),
  CONNECT_ERROR: new ResultCode(10011, "连接失败"),
  DEVICE_LOCKED: new ResultCode(10012, "已锁定设备, 无需调用"),
  EXECUTION_FAILURE: new ResultCode(10013, "执行失败"),
  CONNECT_NOT_SUPPORT: new ResultCode(10014, "未找到对应的连接方式"),
  CAN_NOT_FIND_DEVICE: new ResultCode(10015, "设备不在线或未开机,请重试"),
  isError: isError,
  getErrorMsg: getErrorMsg
}

export {
  defaultError,
  SYSTEM_ERROR,
  ResultCode,
  WebError,
  isError,
  getErrorMsg
}